import { c as _c } from "react/compiler-runtime";
import { Alert } from '@shared/ui-components/alert/alert';
import { AlertVariant } from '@shared/ui-components/alert/alertVariant';
import { ProfilePhoto, type ProfilePhotoContentType } from '@shared/ui-components/profile-photo/profile-photo';
import { PICTURE_UPLOAD_ERROR_ID } from '@shared/utils/constants/fileUpload';
import styles from './profile-photo-dialog-content.module.scss';
const PARENT_CLASSNAME = 'profile-photo-dialog-content';
export type ProfilePhotoDialogContentType = {
  modalDescription: string;
  pictureFileInputHint: string;
  upload: string;
};
type ProfilePhotoDialogContentProps = {
  cmsContent: ProfilePhotoContentType & ProfilePhotoDialogContentType;
  imageSrc: string | undefined;
  profileUploadError?: string | undefined;
};
export const ProfilePhotoDialogContent = t0 => {
  const $ = _c(16);
  const {
    cmsContent,
    imageSrc,
    profileUploadError
  } = t0;
  let t1;
  if ($[0] !== cmsContent.modalDescription) {
    t1 = <p className={styles[`${PARENT_CLASSNAME}__paragraph`]} data-testid="dialog-content-description">{cmsContent.modalDescription}</p>;
    $[0] = cmsContent.modalDescription;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cmsContent.pictureFileInputHint) {
    t2 = <p aria-hidden="true" className={styles[`${PARENT_CLASSNAME}__picture-requirements`]} id="profile-picture-requirements">{cmsContent.pictureFileInputHint}</p>;
    $[2] = cmsContent.pictureFileInputHint;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== profileUploadError) {
    t3 = profileUploadError && <Alert className={styles[`${PARENT_CLASSNAME}__error-message`]} id={PICTURE_UPLOAD_ERROR_ID} message={profileUploadError} variant={AlertVariant.Error} />;
    $[4] = profileUploadError;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== cmsContent.photoCropAriaLiveText || $[7] !== cmsContent.pictureDescription || $[8] !== cmsContent.upload || $[9] !== imageSrc) {
    t4 = !imageSrc && <div className={styles[`${PARENT_CLASSNAME}__photo-container`]} data-testid="dialog-content-photo-container"><div className={styles[`${PARENT_CLASSNAME}__photo`]} data-testid="dialog-content-photo"><ProfilePhoto actionLabelText={cmsContent.upload} cmsContent={{
          photoCropAriaLiveText: cmsContent.photoCropAriaLiveText,
          pictureDescription: cmsContent.pictureDescription
        }} hasBorder={false} imageSrc={imageSrc} isFluid={true} /></div></div>;
    $[6] = cmsContent.photoCropAriaLiveText;
    $[7] = cmsContent.pictureDescription;
    $[8] = cmsContent.upload;
    $[9] = imageSrc;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className={styles[PARENT_CLASSNAME]}>{t1}{t2}{t3}{t4}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};